import FingerprintJS from '@fingerprintjs/fingerprintjs';
import * as bufferFrom from 'buffer-from';
import { publicEncrypt } from 'crypto-browserify';
import { getRemoteConfig, getValue } from 'firebase/remote-config';
import { fetchAndActivate } from 'firebase/remote-config';

// [1] Firebase Remote. Config를 통해서 가져온 public_key 로 fingerprint를 RSA 암호화
// [2] [1]에서 암호화된 내용을 base64로 인코딩
// [3] base64로 인코딩된 fingerprint를 [POST] /public/fingerprints로 넘겨 204 성공 응답값을 받으면 Local Storage에 저장
export const createFingerprintJs = async () => {
  const sentFingerprint = localStorage.getItem('sentFingerprint') === 'true';

  const remoteConfig = getRemoteConfig(app);
  const fpPromise = FingerprintJS.load();
  try {
    await fetchAndActivate(remoteConfig);
    const public_key = await getValue(remoteConfig, 'public_key')._value.replace(/\\n/g, '\n');
    const fpPromiseRes = await fpPromise.then((fp) => fp.get());
    const fingerprintKey = fpPromiseRes.visitorId;
    const encodingFingerprintKey = publicEncrypt(public_key, bufferFrom(fingerprintKey)).toString('base64');
    useFingerprintStore.setState({ fingerprintKey, encodingFingerprintKey });
    !sentFingerprint && createFingerprint();
  } catch (error) {
    console.log(error);
  }
};
